export default __webpack_public_path__ + "static/media/periods1.df6352e8.jpg";